var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSSignGreenRgb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#002B17;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "209.6,135.2 273.5,98.4 245.1,49.3 181.3,86.1 181.7,118.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "181.7,164.9 181.2,197.2 244.6,233.6 273.1,184.7 209.7,148.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "170,79.7 170,6 113.3,6 113.3,79.7 141.7,95.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "141.7,187.8 113.3,203.8 113.3,277.5 170,277.5 170,203.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "101.7,118.7 102.1,86.1 38.3,49.3 9.9,98.4 73.8,135.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "73.7,148.2 9.9,185.1 38.3,234.1 102.1,197.3 101.7,164.8  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "rulers"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSSignGreenRgb);
export default __webpack_public_path__ + "static/media/s_sign_Green_RGB.128e6692731eae5d2178e498a23edc77.svg";
export { ForwardRef as ReactComponent };